<template>
  <div class="subscription-plans-page">
    <Toolbar classes="pt-3">
      <template v-slot:actions>
        <router-link to="/subscription" class="btn btn-sm btn-light-primary">
          <i class="bi bi-arrow-left me-1"></i>
          Voltar
        </router-link>
      </template>
    </Toolbar>

    <div class="container-xxl pb-10">
      <div class="subscription-plans-page__intro mb-8">
        <h1 class="fs-2 fw-bold mb-2">Escolha o plano da sua clínica</h1>
        <p class="text-muted mb-0">
          Compare os planos e selecione o que melhor atende sua operação. O Enterprise é personalizado com o comercial.
        </p>
      </div>

      <div class="row g-4 g-xl-5">
        <div
          v-for="plan in plans"
          :key="plan.id_platform_plan"
          class="col-12 col-md-6 col-xl-3"
        >
          <div
            class="subscription-plans-page__card card h-100"
            :class="cardClasses(plan)"
          >
            <div v-if="plan.is_recommended" class="subscription-plans-page__ribbon">Recomendado</div>
            <div v-if="plan.requires_commercial_contact" class="subscription-plans-page__ribbon subscription-plans-page__ribbon--enterprise">
              Sob medida
            </div>

            <div class="card-body d-flex flex-column">
              <h3 class="fs-4 fw-bold mb-1">{{ plan.name }}</h3>
              <p class="text-muted fs-7 mb-4">{{ plan.description }}</p>

              <div class="subscription-plans-page__price mb-4">
                <template v-if="plan.requires_commercial_contact">
                  <span class="fs-5 fw-bold text-gray-800">Valor sob consulta</span>
                </template>
                <template v-else>
                  <span class="subscription-plans-page__currency">R$</span>
                  <span class="subscription-plans-page__amount">{{ formatMoney(plan.price) }}</span>
                  <span class="text-muted fs-7">/mês</span>
                </template>
              </div>

              <div class="flex-grow-1 mb-4">
                <PlanOfferingPresentation :presentation="plan.presentation" />
              </div>

              <button
                v-if="plan.is_self_service"
                type="button"
                class="btn w-100"
                :class="plan.is_recommended ? 'btn-primary' : 'btn-light-primary'"
                :disabled="loading"
                @click="selectPlan(plan)"
              >
                Selecionar plano
              </button>
              <a
                v-else
                href="mailto:comercial@ubbimed.com.br?subject=Interesse%20no%20plano%20Enterprise%20Ubbi"
                class="btn btn-outline btn-outline-dashed btn-outline-primary w-100"
              >
                <i class="bi bi-envelope me-2"></i>
                Falar com o comercial
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toolbar from '../../components/layouts/auth/Toolbar.vue';
import PlanOfferingPresentation from '../../components/platform_subscription/PlanOfferingPresentation.vue';
import http from '../../helpers/http';
import Alert from '../../helpers/alert';
import Permission from '../../helpers/permission';

export default {
  name: 'SubscriptionPlans',
  components: { Toolbar, PlanOfferingPresentation },
  data() {
    return { plans: [], loading: false };
  },
  created() {
    if (!Permission.has('Manage Place Platform Subscription')) {
      this.$router.replace('/subscription');
      return;
    }
    const placeId = this.$store.state.auth.place?.id_place;
    http.get(`/places/${placeId}/platform-subscription/plans`).then((res) => {
      this.plans = res.data;
    });
  },
  methods: {
    cardClasses(plan) {
      return {
        'subscription-plans-page__card--recommended': plan.is_recommended,
        'subscription-plans-page__card--enterprise': plan.requires_commercial_contact,
      };
    },
    formatMoney(value) {
      return Number(value || 0).toFixed(2).replace('.', ',');
    },
    selectPlan(plan) {
      if (!plan.is_self_service) {
        return;
      }

      this.loading = true;
      const placeId = this.$store.state.auth.place?.id_place;
      http.post(`/places/${placeId}/platform-subscription/change-plan`, {
        id_platform_plan: plan.id_platform_plan,
      }).then(() => {
        Alert.success('Plano alterado. A mudança será aplicada no próximo ciclo.');
        this.$router.push('/subscription');
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.subscription-plans-page__intro {
  max-width: 42rem;
}

.subscription-plans-page__card {
  position: relative;
  border: 1px solid #ebedf3;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.subscription-plans-page__card--recommended {
  border-color: #009ef7;
  box-shadow: 0 10px 30px rgba(0, 158, 247, 0.12);
}

.subscription-plans-page__card--enterprise {
  border-style: dashed;
  border-color: #7239ea;
  background: linear-gradient(180deg, #fdfcff 0%, #fff 100%);
}

.subscription-plans-page__ribbon {
  position: absolute;
  top: 12px;
  right: 12px;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #009ef7;
  color: #fff;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
}

.subscription-plans-page__ribbon--enterprise {
  background: #7239ea;
}

.subscription-plans-page__price {
  min-height: 2.5rem;
}

.subscription-plans-page__currency {
  font-size: 1rem;
  font-weight: 600;
  color: #7e8299;
  vertical-align: top;
}

.subscription-plans-page__amount {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
  color: #181c32;
}
</style>
